import { debug } from 'console';
import GameManager from '../../../core/GameManager';
import { customRouter } from '../../../CustomRouter';
import BleedingControlScenario, { ScenarioEndType, ScenarioSceneType, StepToSkip } from '../../../misc/BleedingControlScenario';
import { constants } from '../../../misc/helpers';
import MainTutorialScenarioEnd from './MainTutorialScenarioEnd';
import MainTutorialScenarioStep1 from './MainTutorialScenarioStep1';
import MainTutorialScenarioStep2 from './MainTutorialScenarioStep2';
import MainTutorialScenarioSteps12And13And14And15 from './MainTutorialScenarioSteps12And13And14And15';
import MainTutorialScenarioSteps3And4 from './MainTutorialScenarioSteps3And4';
import MainTutorialScenarioSteps5And6 from './MainTutorialScenarioSteps5And6';
import MainTutorialScenarioSteps7And8 from './MainTutorialScenarioSteps7And8';
import MainTutorialScenarioSteps9And10And11 from './MainTutorialScenarioSteps9And10And11';

export default class MainTutorialScenario extends BleedingControlScenario {
	public correctFeedbackCounter = 0;
	public incorrectFeedbackCounter = 0;
	public currentCamSliderValue = 50;
	public wasDraggedAllLeft = false;
	public checkIfSkipped = false;
	
	constructor(gameManager: GameManager, scenarioName: string, public scenarioSceneToLoad: ScenarioSceneType, public endAt: ScenarioEndType, stepsToSkip?: StepToSkip[]) {
		super(gameManager, scenarioName, scenarioSceneToLoad, endAt, stepsToSkip);
	}

	start() {
		this.goToStep0();
	}

	doStuffIfStepsWereSkipped() {
		if(this.checkIfSkipped) {
			this.playSequence('EnableSecondCamera', null, () => {
				this.playSequence('TransitionToUnsafe');
			});
		}
	}

	goToStep0() {
		var context = this;
		switch(this.scenarioSceneToLoad) {
			case ScenarioSceneType.Tutorial:
				//context.checkIfSkipped = true;
                //context.loadTutorialScene(() => context.goToSteps7And8());
                context.loadTutorialScene(() => context.goToStep1());
				break;
		}
	}

	goToStep1() {
		var context = this;
		new MainTutorialScenarioStep1(this, () => context.goToStep2()).start();
	}

	goToStep2() {
		var context = this;
		new MainTutorialScenarioStep2(this, () => { 
			context.currentCamSliderValue = 50;
			context.goToSteps3And4();
		 }).start();
	}

	goToSteps3And4() {
		var context = this;
		new MainTutorialScenarioSteps3And4(this, () => { 
			context.goToSteps5And6();
		 }).start();
	}

	goToSteps5And6() {
		var context = this;
		new MainTutorialScenarioSteps5And6(this, () => { 
			context.goToSteps7And8();
		 }).start();
	}

	goToSteps7And8() {
		var context = this;
		new MainTutorialScenarioSteps7And8(this, () => { 
			context.goToSteps9And10And11();
		 }).start();
	}

	goToSteps9And10And11() {
		var context = this;
		new MainTutorialScenarioSteps9And10And11(this, () => { 
			context.goToSteps12And13And14And15();
		 }).start();
	}

	goToSteps12And13And14And15() {
		var context = this;
		new MainTutorialScenarioSteps12And13And14And15(this, () => { 
			context.goToScenarioEnd();
		 }).start();
	}

	goToScenarioEnd() {
		new MainTutorialScenarioEnd(this).start();
	}

	public showTimer() {
		var context = this;
		context.gameManager.UiManager.showUi(constants.InGameUINames.PauseMenu, {
			timer: {
				dispatch: this.gameManager.customData.dispatch,
				penalized: false,
				startTimeInSeconds: 240
			},
			returnToMainMenu: {
				onClick: () => context.showExitToMainMenuConfirmation()
			}
		});
	}

	public showExitToMainMenuConfirmation() {
		var context = this;
		this.gameManager.UiManager.showUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Are you sure you want to return to main menu?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.showMainMenu()
			},
			incorrectButton: {
				title: 'No',
				onClick: () => { }
			}
		});
	}

	public showMainMenu() {
		var url = new URL(window.location.href);
		var search_params = url.searchParams;
		
		search_params.set('w', '0');

		url.search = search_params.toString();

		window.location.href = url.toString();
		//window.location.href = process.env.PUBLIC_URL
	}


	// public learningReview() {
	// 	var context = this;
	// 	context.step1ShowQuestion();
	// }

	public closeScenario() {
		var context = this;
		context.showMainMenu();
	}

	public showIncorrectFeedback(msg: string, onTryAgain: () => void) {
		var isTalking = false;

		if (this.incorrectFeedbackCounter === 0) {
			isTalking = true;
			var context = this;
			this.playSound('1', '6', () => {
				context.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
					onTryAgain();
			});
		}

		this.incorrectFeedbackCounter++;

		this.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
		this.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {
			isCorrect: false,
			message: msg
		});

		if (!isTalking) {
			setTimeout((context) => {
				context.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
					onTryAgain();
			}, 5000, this);
		}
	}

	public showCorrectFeedback(msg: string, onDone: () => void) {
		var isTalking = false;

		if (this.correctFeedbackCounter === 0) {
			isTalking = true;
			var context = this;
			this.playSound('1', '4', () => {
				context.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
				onDone();
			});
		}

		this.correctFeedbackCounter++;

		this.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
		this.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {
			message: msg,
			isCorrect: true
		});

		if (!isTalking) {
			setTimeout((context) => {
				context.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
				onDone();
			}, 5000, this);
		}
	}

	public showTryAgainUI(playTryAgainAudio: boolean, playNextButton: boolean, onTryAgain: () => void, onNext: () => void) {
		this.gameManager.UiManager.hideaAllUis();

		var questionData = {
			title: 'Would you like to try again?',
			disabled: true,
			correctButton: {
				title: 'Try Again',
				onClick: () => {
					if (!this.gameManager || !this.gameManager.UiManager) {
						return;
					}
					this.gameManager.UiManager.hideaAllUis();
					onTryAgain();
				}
			},
			incorrectButton: {
				title: 'Next',
				onClick: () => {
					if (!this.gameManager || !this.gameManager.UiManager) {
						return;
					}
					this.gameManager.UiManager.hideaAllUis();
					onNext();
				}
			},
			randomize: false
		};

		if (playTryAgainAudio) {
			this.playSound('2', '6', () => {
				if (playNextButton) {
					this.playSound('2', '7', () => {
						questionData.disabled = false;
						this.gameManager.UiManager.showUi(constants.InGameUINames.BinaryQuestion, questionData);
					});
				} else {
					questionData.disabled = false;
					this.gameManager.UiManager.showUi(constants.InGameUINames.BinaryQuestion, questionData);
				}
			});
		} else {
			questionData.disabled = false;
			this.gameManager.UiManager.showUi(constants.InGameUINames.BinaryQuestion, questionData);

		}

		this.gameManager.UiManager.showUi(constants.InGameUINames.BinaryQuestion, questionData);
	}

	public rotateCameraNew(setDraggedLeft: boolean, max1: number, max2: number, onIsSufficient: () => void, onIsNotSufficient: () => void) {
		var prevPercentage = 50;
		var isSufficient = false;
		var context = this;
		context.wasDraggedAllLeft = setDraggedLeft;
		var data = {
			currentValue: this.currentCamSliderValue,
			dispatch: context.gameManager.customData.dispatch,
			disabled: true,
			glowing: true,
			onUpdate: (percentage: number) => {
				context.currentCamSliderValue = percentage * 100;
				if (prevPercentage === percentage) {
					return;
				}

				prevPercentage = percentage;

				if(context.wasDraggedAllLeft) {
					if (isSufficient && (percentage >= max1 && percentage <= max2)) {
						return;
					} 
					else if (!isSufficient && (percentage < max1 || percentage > max2)) {
						return;
					}
					if (percentage >= max1 && percentage <= max2) {
						isSufficient = true;
						onIsSufficient();
					} 
					else {
						isSufficient = false;
						onIsNotSufficient();
					}
				} 
				else {
					if (percentage <= 0) {
						context.wasDraggedAllLeft = true;
					}
					isSufficient = false;
					onIsNotSufficient();
				}
				
			}
		};
			data.disabled = false;
		context.gameManager.UiManager.showUi(constants.InGameUINames.RotateCamera, data);
	}

}